<template>
    <div>
        <BTable small :items="positions" :fields="fields_item" caption-top stacked="sm">
            <template #table-caption>
                <BButton variant="success" @click="addRow">Додати</BButton>
            </template>
            
            <template v-slot:cell(title)="{value, item, field: { key },index}">
                <BFormInput v-model="item[key]" v-on:keydown.enter="go_next(index,'titletab')"
                              class="titletab"
                              type="text"
                              placeholder="Позиція" :state="value.length > 2 ? true : false"/>
            </template>
            
            <template v-slot:cell(catalog_number)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]"
                              v-on:keydown.enter="go_next(index,'catalog_numbertab')"
                              class="catalog_numbertab"
                              type="text"
                              placeholder="Каталожний номер"/>
            </template>
            
            <template v-slot:cell(unit)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]"
                              v-on:keydown.enter="go_next(index,'unittab')"
                              class="unittab"
                              type="text"
                              placeholder="Одиниця виміру"/>
            </template>
            
            <template v-slot:cell(is_original)="{ value, item, field: { key },index}">
                <v-select
                    label="text"
                    :options="opt_original"
                    v-on:keydown.enter="go_next(index,'is_originaltab')"
                    class="is_originaltab"
                    v-model="item[key]"
                
                ></v-select>
            </template>
            
            <template v-slot:cell(quantity)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]"
                              type="text"
                              v-on:keydown.enter="go_next(index,'quantitytab')"
                              v-on:keyup="chkdot(item,key,$event)"
                              class="quantitytab"
                              :state="value > 0 ? true : false"
                />
            </template>
            
            <template v-slot:cell(max_price)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]"
                              type="text"
                              v-on:keydown.enter="go_next(index,'max_pricetab')"
                              v-on:keyup="chkdot(item,key,$event)"
                              class="max_pricetab"
                              :state="value > 0 ? true : false"
                />
            </template>
            <template v-slot:cell(min_step)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]"
                              type="text"
                              v-on:keydown.enter="go_next(index,'min_steptab')"
                              v-on:keyup="chkdot(item,key,$event)"
                              
                              class="min_steptab"
                              :state="value > 0 ? true : false"
                />
            </template>
            
            <template v-slot:cell(note)="{ value, item, field: { key },index}">
                <BFormInput v-model="item[key]" type="text" v-on:keydown.enter="go_next(index,'notetab')" class="notetab"/>
            </template>
            
            <template v-slot:cell(dell_row)="row">
                <div class='icon-stack cursor-pointer fs-xxl' v-on:click="dellRaw(row)">
                    <i class="base base-1 icon-stack-3x opacity-100 color-danger-600"></i>
                    <i class="far fa-trash-alt icon-stack-1x opacity-100 color-white"></i>
                </div>
            </template>
        
        
        </BTable>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {
    BTable,
    BFormInput,
    BButton,
    
} from 'bootstrap-vue-next';


export default {
    name: "positions",
    
    components : {
        BTable,
        BFormInput,
        BButton,
        vSelect
    },
    
    props:
        {
            positions : {
                type : Array
            },
            
            is_reduction: {
                type: Boolean,
                default: false
            },
            
            tender_type: {
                type: String,
                default: ''
            },
        },
    
    mounted: function () {
        var thElm;
        var startOffset;
        
        Array.prototype.forEach.call(
            document.querySelectorAll("table th"),
            function (th) {
                th.style.position = 'relative';
                
                var grip = document.createElement('div');
                grip.innerHTML = "&nbsp;";
                grip.style.top = 0;
                grip.style.right = 0;
                grip.style.bottom = 0;
                grip.style.width = '5px';
                grip.style.position = 'absolute';
                grip.style.cursor = 'col-resize';
                grip.addEventListener('mousedown', function (e) {
                    thElm = th;
                    startOffset = th.offsetWidth - e.pageX;
                    
                });
                
                th.appendChild(grip);
            });
        
        document.addEventListener('mousemove', function (e) {
            if (thElm) {
                thElm.style.width = startOffset + e.pageX + 'px';
            }
        });
        
        
        document.addEventListener('mouseup', function () {
            thElm = undefined;
        });
        
        
    },
    
    data() {
        return {
            opt_original: ["Оригінал", "Аналог"],
            first_simple: [{key: 'title', label: "Позиція", sortable: true},
                {key: 'catalog_number', label: "Кат. номер", sortable: true},
                {key: 'unit', label: "Од.", sortable: true},
                {key: 'is_original', label: "Оригінал", sortable: true},
                {key: 'quantity', label: "К-сть", sortable: true},
                {key: 'note', label: "Примітка", sortable: true},
                {key: 'dell_row', label: "",}],
            
            second_simple: [{key: 'title', label: "Позиція", sortable: true},
                {key: 'catalog_number', label: "Кат. номер", sortable: true},
                {key: 'unit', label: "Од.", sortable: true},
                {key: 'is_original', label: "Оригінал", sortable: true},
                {key: 'quantity', label: "К-сть", sortable: true},
                
                {key: 'note', label: "Примітка", sortable: true},
                {key: 'dell_row', label: "",}],
            
            second_reduction: [{key: 'title', label: "Позиція", sortable: true},
                {key: 'catalog_number', label: "Кат. номер", sortable: true},
                {key: 'unit', label: "Од.", sortable: true},
                {key: 'is_original', label: "Оригінал", sortable: true},
                {key: 'quantity', label: "К-сть", sortable: true},
                {key: 'max_price', label: "Ціна", sortable: true},
                {key: 'min_step', label: "Крок", sortable: true},
                {key: 'note', label: "Примітка", sortable: true},
                {key: 'dell_row', label: "",}
            ],
        }
    },
    
    methods: {
        
        go_next(index, classname, event) {
            
            let els = document.getElementsByClassName(classname);
            
            if (els.length - 1 > index) {
                els[index + 1].focus();
            }
        },
        
        chkdot(item, key, event) {
            var tmp = item[key];
            // replace everything that's not a number or comma or decimal
            tmp = tmp.replace(/[^0-9,.]/g, "");
            // replace commas with decimal
            tmp = tmp.replace(/,/, ".");
            // set element value to new value
            item[key] = tmp;
        },
        
        addRow() {
            this.positions.push({
                title: '',
                catalog_number: '',
                unit: 'шт.',
                is_original: 'Оригінал',
                quantity: 1,
                note: ''
            })
        },
        
        dellRaw(row) {
            this.positions.splice(row.index, 1);
        },
    },
    
    computed: {
        
        fields_item: function () {
            let fields_item = this.first_simple;
            switch (this.tender_type) {
                case  'second_reduction' :
                    fields_item = this.second_reduction;
                    break;
                case  'second_simple' :
                    fields_item = this.second_simple;
                    break;
            }
            return fields_item;
        }
        
        
    },
    
    
}

</script>


